import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PartneringSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PartneringSVG;
